@if (tableDataSourceDirective.loading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@if (data.warningMessage) {
  <div class="flex justify-center gap-4 items-center text-yellow-500">
    <mat-icon>warning</mat-icon>
    <div>{{ data.warningMessage }}</div>
  </div>
}
<div class="table-scroll-container mt-4 overflow-x-auto overscroll-auto">
  <table #tableDataSourceDirective="eurogardTableDataSource"
         [id]="id ?? 'table-select'"
         [paginator]="paginator"
         [parameters]="data.parameters"
         mat-table
         matSort
         eurogard-filter-header-row
         eurogardTableDataSource>

    @if (data.multiple) {
      <ng-container matColumnDef="select" [sticky]="true">
        <th *matHeaderCellDef class="drop-shadow-2xl" mat-header-cell eurogard-checkbox-header-cell></th>
        <td
          *matCellDef="let element"
          [element]="element"
          class="drop-shadow-2xl"
          mat-cell
          eurogard-checkbox-cell
        ></td>
      </ng-container>
    }

    @if (hasSomeFilterColumn) {
      @if (data.multiple) {
        <ng-container [matColumnDef]="'filter__select'">
          <th *matHeaderCellDef mat-header-cell></th>
        </ng-container>
      }

      @for (item of data.columns | keyvalue; track $index) {

        @if (item.value.filter) {

          @switch(item.value.type) {

            @case('date') {
              <ng-container [matColumnDef]="'filter__' + item.key">
                <th *matHeaderCellDef mat-header-cell></th>
              </ng-container>
            }

            @case('boolean') {
              <ng-container [matColumnDef]="'filter__' + item.key">
                <th *matHeaderCellDef mat-header-cell></th>
              </ng-container>
            }

            @case('enum') {
              <ng-container [matColumnDef]="'filter__' + item.key">
                <th *matHeaderCellDef mat-header-cell>
                  @if (item.value.filteredEnumValues !== undefined) {

                    <mat-form-field subscriptSizing="dynamic" class="grow-0 my-4">
                      <mat-label>{{ item.value.label }}</mat-label>

                      <mat-select [formControlName]="item.key">
                        <mat-option [value]="item.value.filteredEnumValues" i18n>All</mat-option>

                        @for (type of item.value.enumValues(); track $index) {
                          @if (item.value.filteredEnumValues.includes(type.value)) {
                            <mat-option [value]="[type.value]">{{ type.display }}</mat-option>
                          }
                        }

                      </mat-select>
                    </mat-form-field>

                  } @else {

                    <mat-form-field subscriptSizing="dynamic" class="grow-0 my-4">
                      <mat-label>{{ item.value.label }}</mat-label>

                      <mat-select [formControlName]="item.key">
                        @for (type of item.value.enumValues(); track $index) {
                          <mat-option [value]="type.value">{{ type.display }}</mat-option>
                        }
                      </mat-select>

                      <button tabindex="-1" type="button" matSuffix mat-icon-button rxapInputClearButton>
                        <mat-icon>clear</mat-icon>
                      </button>
                    </mat-form-field>

                  }
                </th>
              </ng-container>
            }

            @case('icon') {
              <ng-container [matColumnDef]="'filter__' + item.key">
                <th *matHeaderCellDef mat-header-cell>
                  <mat-form-field subscriptSizing="dynamic" class="grow-0 my-4">
                    <mat-label>{{ item.value.label }}</mat-label>

                    <mat-select [formControlName]="item.key">
                      @for (icon of item.value.icons; track $index) {
                        @if (!icon.hidden) {
                          <mat-option [value]="icon.value">{{ icon.tooltip }}</mat-option>
                        }
                      }
                    </mat-select>

                    <button tabindex="-1" type="button" matSuffix mat-icon-button rxapInputClearButton>
                      <mat-icon>clear</mat-icon>
                    </button>
                  </mat-form-field>
                </th>
              </ng-container>
            }

            @default {
              <ng-container [matColumnDef]="'filter__' + item.key">
                <th *matHeaderCellDef mat-header-cell>
                  <mat-form-field subscriptSizing="dynamic" class="grow-0 my-4">
                    <mat-label>{{ item.value.label }}</mat-label>

                    <input
                      [formControlName]="item.key"
                      [placeholder]="'Enter ' + item.value.label"
                      i18n-placeholder
                      matInput
                      parentControlContainer
                    />

                    <button mat-icon-button matSuffix rxapInputClearButton>
                      <mat-icon>clear</mat-icon>
                    </button>
                  </mat-form-field>
                </th>
              </ng-container>
            }

          }

        }

        @if (!item.value.filter) {
          <ng-container [matColumnDef]="'filter__' + item.key">
            <th *matHeaderCellDef mat-header-cell>{{ data.showHeader ? '' : item.value.label }}</th>
          </ng-container>
        }
      }
    }


    @for (item of data.columns | keyvalue; track $index) {
      @switch (item.value.type) {
        @case ('date') {
          <ng-container [matColumnDef]="item.key">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ item.value.label }}</th>
            <td
              *matCellDef="let element"
              [format]="item.value['format']"
              [eurogard-date-cell]="element | getFromObject:item.key"
              mat-cell
            ></td>
          </ng-container>
        }

        @case ('boolean') {
          <ng-container [matColumnDef]="item.key">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ item.value.label }}</th>
            <td
              *matCellDef="let element"
              [eurogard-boolean-cell]="element | getFromObject:item.key"
              mat-cell
            ></td>
          </ng-container>
        }

        @case ('enum') {
          <ng-container [matColumnDef]="item.key">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ item.value.label }}</th>
            <td *matCellDef="let element" mat-cell>
              {{ item.value.enumValues() | findByValue : (element | getFromObject:item.key) : 'display' }}
            </td>
          </ng-container>
        }

        @case ('icon') {
          <ng-container [matColumnDef]="item.key">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>{{ item.value.label }}</th>
            <td *matCellDef="let element" mat-cell>
              @if (item.value.icons) {
                <mat-icon
                  matTooltip="{{ item.value.icons | findByValue : (element | getFromObject:item.key) : 'tooltip' }}"
                >{{ item.value.icons | findByValue : (element | getFromObject:item.key) : 'icon' }}</mat-icon>
              } @else {
                <mat-icon
                  style.color="{{ (element | getFromObject: item.key | getFromObject: 'fontColor') }}"
                  svgIcon="{{ (element | getFromObject: item.key | getFromObject: 'svgIcon') }}"
                ></mat-icon>
              }
            </td>
          </ng-container>
        }

        @default {
          <ng-container [matColumnDef]="item.key">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
              {{ item.value.label }}
            </th>
            <td *matCellDef="let element" mat-cell>
              {{ element | getFromObject:item.key }}
            </td>
          </ng-container>
        }
      }
    }

    @if (hasSomeFilterColumn) {
      <tr *matHeaderRowDef="filterDisplayColumns" class="filter-header" mat-header-row></tr>
    }

    @if (data.showHeader) {
      <tr *matHeaderRowDef="displayColumns" mat-header-row></tr>
    }

    <tr
      (click)="toggleRow(element)"
      *matRowDef="let element; columns: displayColumns"
      [@rowsAnimation]
      class="cursor-pointer"
      mat-row
    ></tr>

  </table>
</div>
<mat-paginator
  #paginator="matPaginator"
  [pageSizeOptions]="[5, 10, 25, 50, 75, 100, 150, 200]"
  [pageSize]="10"
></mat-paginator>

<ng-template rxapWindowFooter>
  <div class="flex flex-row items-center gap-4">
    @if (data.multiple) {
      <button (click)="select()" [disabled]="hasNotSelected$ | async" class="grow-0" mat-raised-button type="button">
        <ng-container i18n>Select</ng-container>
      </button>
    }

    <button (click)="close()" class="grow-0" mat-stroked-button type="button">
      <ng-container i18n>Cancel</ng-container>
    </button>

    @if (!data.multiple) {
      <span class="hint" i18n>Click on a row to select an entry.</span>
    }
  </div>
</ng-template>
